import { DateTime } from 'luxon'

import { AccountMapper } from '@/core/api/mappers/account/accountMapper'

import { CampaignResponseDTO } from '@core/api/dtos/response/campaign/campaign'
import { Campaign } from '@core/api/entities/campaign/campaign'
import { AdvertMapper } from '@core/api/mappers/campaign/advertMapper'
import { GroupMapper } from '@core/api/mappers/groupMapper'

export class CampaignMapper {
	static toEntity(data: CampaignResponseDTO): Campaign {
		return new Campaign({
			id: data.id,
			accountId: data.account_id,
			name: data.name,
			rrule: data.rrule,
			rruleType: data.rrule_type,
			exdate: data.exdate,
			type: data.type,
			priority: data.priority,
			createdAt: DateTime.fromISO(data.created_at),
			adverts:
				data.adverts?.data.map((advert) => AdvertMapper.toEntity(advert)) || [],
			account: data.account?.data
				? AccountMapper.toEntity(data.account.data)
				: undefined,
			groups:
				data.groups?.data.map((group) => GroupMapper.toEntity(group)) || [],
		})
	}

	static toEntities(data: CampaignResponseDTO[]): Campaign[] {
		return data.map((item) => this.toEntity(item))
	}
}
